import React from "react";

import { Fleet } from "Models/fleet";
import { useTranslation } from "react-i18next";

import { ResourceIcons } from "../ResourceIcons";
import { TeamEquipment } from "./components/TeamsEquipment";
import { TeamEquipments, TeamEquipmentsContainer, TeamEquipmentsIcon } from "./styles";

interface ResourceTeamEquipmentsProps {
  equipments: Fleet[];
}

export const ResourceTeamEquipmentsCard: React.FC<ResourceTeamEquipmentsProps> = ({
  equipments,
}) => {
  const isEmpty = !equipments.length;
  const { t: translate } = useTranslation();

  return (
    <TeamEquipmentsContainer isActive={!isEmpty}>
      <TeamEquipmentsIcon>
        <ResourceIcons name="truck" size={20} />
      </TeamEquipmentsIcon>

      <TeamEquipments isCentered={isEmpty || equipments.length === 1}>
        {isEmpty && translate("noEquipmentAdded")}

        {equipments.map((equipment) => {
          return (
            <TeamEquipment
              key={`${equipment.fleetNumber}-${equipment.id}-equipment`}
              name={equipment?.fleetNumber}
              isSubcontractor={!!equipment.subcontractorId}
            />
          );
        })}
      </TeamEquipments>
    </TeamEquipmentsContainer>
  );
};
